import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [mode, setMode] = useState('creation');

  const value = {
    mode,
    setMode,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
